import { render, staticRenderFns } from "./Biller.vue?vue&type=template&id=064c3e7a&scoped=true"
import script from "./Biller.vue?vue&type=script&lang=js"
export * from "./Biller.vue?vue&type=script&lang=js"
import style0 from "./Biller.vue?vue&type=style&index=0&id=064c3e7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064c3e7a",
  null
  
)

export default component.exports